var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      ref: "modal",
      staticClass: "candidat-overview-modal",
      attrs: { heading: "Candidate Overview" }
    },
    [
      _c(
        "Accordion",
        [
          _c(
            "AccordionItem",
            [
              _c("template", { slot: "accordion-trigger" }, [
                _vm._v("\n                Candidate Info\n            ")
              ]),
              _vm._v(" "),
              _c("template", { slot: "accordion-content" }, [
                _c("div", { staticClass: "grid-x grid-padding-x" }, [
                  _c(
                    "div",
                    { staticClass: "cell small-12 px-5" },
                    [
                      _c(
                        "Accordion",
                        [
                          _c(
                            "AccordionItem",
                            [
                              _c("template", { slot: "accordion-trigger" }, [
                                _vm._v(
                                  "\n                                    Printed CV (Last Update " +
                                    _vm._s(
                                      _vm.convertDate(
                                        _vm.jobApplication.user.modified
                                      )
                                    ) +
                                    ")\n                                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("template", { slot: "accordion-content" }, [
                                _c("div", { staticClass: "cell small-12" }, [
                                  _c("iframe", {
                                    attrs: {
                                      src: "" + _vm.jobApplication.user.cv_url,
                                      width: "100%",
                                      height: "1000px"
                                    }
                                  })
                                ])
                              ])
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "AccordionItem",
                            [
                              _c("template", { slot: "accordion-trigger" }, [
                                _vm._v(
                                  "\n                                    Personal CV\n                                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("template", { slot: "accordion-content" }, [
                                _c("div", { staticClass: "cell small-12" }, [
                                  _vm.jobApplication.user.personal_cv_url
                                    ? _c("iframe", {
                                        attrs: {
                                          src:
                                            "" +
                                            _vm.jobApplication.user
                                              .personal_cv_url,
                                          width: "100%",
                                          height: "1000px"
                                        }
                                      })
                                    : _c("div", [
                                        _c("h4", [
                                          _vm._v("No Personal CV available")
                                        ])
                                      ])
                                ])
                              ])
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "AccordionItem",
                            [
                              _c("template", { slot: "accordion-trigger" }, [
                                _vm._v(
                                  "\n                                    Introduction Notes\n                                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("template", { slot: "accordion-content" }, [
                                _c(
                                  "div",
                                  { staticClass: "grid-x grid-padding-x" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "cell small-12 medium-6" },
                                      [
                                        _vm.jobApplication.user
                                          .video_path_cdn !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "card p-3" },
                                              [
                                                _c("h4", [
                                                  _vm._v("Video Note")
                                                ]),
                                                _vm._v(" "),
                                                _c("iframe", {
                                                  attrs: {
                                                    src:
                                                      _vm.jobApplication.user
                                                        .video_path_cdn,
                                                    width: "640",
                                                    height: "360"
                                                  }
                                                })
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "card p-3" },
                                              [
                                                _c("h4", [
                                                  _vm._v(
                                                    "No Introduction information available"
                                                  )
                                                ])
                                              ]
                                            )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "cell small-12 medium-6" },
                                      [
                                        _vm.jobApplication.user
                                          .audio_path_cdn !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "card p-3" },
                                              [
                                                _c("h4", [
                                                  _vm._v("Audio Note")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "audio",
                                                  { attrs: { controls: "" } },
                                                  [
                                                    _c("source", {
                                                      attrs: {
                                                        src:
                                                          _vm.jobApplication
                                                            .user
                                                            .audio_path_cdn,
                                                        type: "audio/mpeg"
                                                      }
                                                    }),
                                                    _vm._v(
                                                      "\n                                                    Your browser does not support the audio element.\n                                                "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "card p-3" },
                                              [
                                                _c("h4", [
                                                  _vm._v(
                                                    "No Introduction information available"
                                                  )
                                                ])
                                              ]
                                            )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "AccordionItem",
            {
              attrs: { name: "application_history" },
              on: { opened: _vm.opened }
            },
            [
              _c("template", { slot: "accordion-trigger" }, [
                _vm._v("\n                Application History\n            ")
              ]),
              _vm._v(" "),
              _c("template", { slot: "accordion-content" }, [
                _c("table", [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("Req Number")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Date Applied")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Phase")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Status")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.applicationHistories, function(
                      applicationHistory
                    ) {
                      return _c("tr", { key: applicationHistory.id }, [
                        _c("td", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "/recruiter/active-requisitions/applicant/" +
                                  _vm.jobApplication.id
                              }
                            },
                            [
                              _vm._v(
                                "\n                                    Req #" +
                                  _vm._s(
                                    applicationHistory.job.requisition_id
                                  ) +
                                  " " +
                                  _vm._s(applicationHistory.job.title) +
                                  "\n                                "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(applicationHistory.created))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(applicationHistory.application_phase))
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                applicationHistory.status === null
                                  ? "still active"
                                  : applicationHistory.status
                              ) +
                              "\n                                "
                          ),
                          applicationHistory.status === "failed"
                            ? _c("span", { staticClass: "text-danger" }, [
                                _c("br"),
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(applicationHistory.fail_reason) +
                                    "\n                                "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "AccordionItem",
            {
              attrs: { name: "client_communications" },
              on: { opened: _vm.opened }
            },
            [
              _c("template", { slot: "accordion-trigger" }, [
                _vm._v(
                  "\n                All Client Communications\n            "
                )
              ]),
              _vm._v(" "),
              _c("template", { slot: "accordion-content" }, [
                _c("div", { staticClass: "cell small-12" }, [
                  _c("div", { staticClass: "grid-x grid-padding-x" }, [
                    _c(
                      "div",
                      { staticClass: "cell small-12 px-5" },
                      [
                        _c(
                          "Accordion",
                          [
                            _c(
                              "AccordionItem",
                              [
                                _c("template", { slot: "accordion-trigger" }, [
                                  _vm._v(
                                    "\n                                        Private Message\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("template", { slot: "accordion-content" }, [
                                  _c("div", { staticClass: "cell small-12" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "grid-x grid-padding-x px-3"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "bg-white cell small-12 p-0"
                                          },
                                          [
                                            _c(
                                              "Accordion",
                                              _vm._l(
                                                _vm.privateMessages,
                                                function(privateMessage) {
                                                  return _c(
                                                    "AccordionItem",
                                                    {
                                                      key: privateMessage.id,
                                                      staticClass: "mb-0"
                                                    },
                                                    [
                                                      _c(
                                                        "template",
                                                        {
                                                          slot:
                                                            "accordion-trigger"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                                Recruiter: " +
                                                              _vm._s(
                                                                privateMessage
                                                                  .recruiter
                                                                  .full_name
                                                              ) +
                                                              "\n                                                            "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "template",
                                                        {
                                                          slot:
                                                            "accordion-content"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "bg-white"
                                                            },
                                                            [
                                                              privateMessage.sms_messages
                                                                ? _c(
                                                                    "table",
                                                                    {
                                                                      staticClass:
                                                                        "unstriped"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "thead",
                                                                        [
                                                                          _c(
                                                                            "tr",
                                                                            [
                                                                              _c(
                                                                                "th",
                                                                                [
                                                                                  _vm._v(
                                                                                    "Sender"
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "th",
                                                                                [
                                                                                  _vm._v(
                                                                                    "Content"
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "th",
                                                                                [
                                                                                  _vm._v(
                                                                                    "Date Sent"
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "tbody",
                                                                        _vm._l(
                                                                          privateMessage.sms_messages,
                                                                          function(
                                                                            comm
                                                                          ) {
                                                                            return _c(
                                                                              "tr",
                                                                              {
                                                                                key:
                                                                                  comm.id
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "td",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        comm
                                                                                          .user
                                                                                          .full_name
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "td",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        comm.content
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "td",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.convertDate(
                                                                                          comm.created
                                                                                        )
                                                                                      ) +
                                                                                        "\n                                                                                "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          }
                                                                        ),
                                                                        0
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    2
                                                  )
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.applicationHistories, function(
                              applicationHistory
                            ) {
                              return _c(
                                "AccordionItem",
                                { key: applicationHistory.id },
                                [
                                  _c(
                                    "template",
                                    { slot: "accordion-trigger" },
                                    [
                                      _vm._v(
                                        "\n                                        Req #" +
                                          _vm._s(
                                            applicationHistory.job
                                              .requisition_id
                                          ) +
                                          " " +
                                          _vm._s(applicationHistory.job.title) +
                                          "\n                                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "template",
                                    { slot: "accordion-content" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "cell small-12" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "grid-x grid-padding-x px-3"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bg-white cell small-12 p-0"
                                                },
                                                [
                                                  applicationHistory.job_application_communications
                                                    ? _c(
                                                        "table",
                                                        {
                                                          staticClass:
                                                            "unstriped"
                                                        },
                                                        [
                                                          _c("thead", [
                                                            _c("tr", [
                                                              _c("th", [
                                                                _vm._v(
                                                                  "Subject"
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("th", [
                                                                _vm._v("Type")
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("th", [
                                                                _vm._v(
                                                                  "Recipient"
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("th", [
                                                                _vm._v(
                                                                  "Date Sent"
                                                                )
                                                              ])
                                                            ])
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "tbody",
                                                            _vm._l(
                                                              applicationHistory.job_application_communications,
                                                              function(comm) {
                                                                return _c(
                                                                  "tr",
                                                                  {
                                                                    key: comm.id
                                                                  },
                                                                  [
                                                                    _c("td", [
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          attrs: {
                                                                            target:
                                                                              "blank",
                                                                            href:
                                                                              "/recruiter/active-requisitions/communications-log/" +
                                                                              comm.id
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                                                        " +
                                                                              _vm._s(
                                                                                comm.subject
                                                                              ) +
                                                                              "\n                                                                    "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("td", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          comm.type
                                                                        )
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("td", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          comm.recipient
                                                                        )
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("td", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.convertDate(
                                                                            comm.created
                                                                          )
                                                                        )
                                                                      )
                                                                    ])
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                2
                              )
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "AccordionItem",
            { attrs: { name: "recruiter_notes" }, on: { opened: _vm.opened } },
            [
              _c("template", { slot: "accordion-trigger" }, [
                _vm._v("\n                All Recruiter Notes\n            ")
              ]),
              _vm._v(" "),
              _c("template", { slot: "accordion-content" }, [
                _c("div", { staticClass: "cell small-12" }, [
                  _c("div", { staticClass: "grid-x grid-padding-x" }, [
                    _c(
                      "div",
                      { staticClass: "cell small-12 px-5" },
                      [
                        _c(
                          "Accordion",
                          [
                            _c(
                              "AccordionItem",
                              [
                                _c("template", { slot: "accordion-trigger" }, [
                                  _vm._v(
                                    "\n                                        Important Recruiter Notes on Candidate\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("template", { slot: "accordion-content" }, [
                                  _c("table", { staticClass: "unstriped" }, [
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", [_vm._v("Recruiter")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("Note")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("Date Created")])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      _vm._l(_vm.importantNotes, function(
                                        importantNote
                                      ) {
                                        return _c(
                                          "tr",
                                          { key: importantNote.id },
                                          [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(importantNote.recruiter)
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(importantNote.note))
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(importantNote.date))
                                            ])
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ])
                                ])
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "AccordionItem",
                              [
                                _c("template", { slot: "accordion-trigger" }, [
                                  _vm._v(
                                    "\n                                        Recruiter Notes\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("template", { slot: "accordion-content" }, [
                                  _c("table", { staticClass: "unstriped" }, [
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", [_vm._v("Req Number")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("Note")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("Recruiter")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("Date Created")])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      _vm._l(
                                        _vm.applicationHistories.filter(
                                          function(applicationHistory) {
                                            return (
                                              applicationHistory.recruiter_notes !==
                                              null
                                            )
                                          }
                                        ),
                                        function(applicationHistory) {
                                          return _c(
                                            "tr",
                                            { key: applicationHistory.id },
                                            [
                                              _c("td", [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "/recruiter/active-requisitions/applicant/" +
                                                        _vm.jobApplication.id
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                            Req #" +
                                                        _vm._s(
                                                          applicationHistory.job
                                                            .requisition_id
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          applicationHistory.job
                                                            .title
                                                        ) +
                                                        "\n                                                        "
                                                    )
                                                  ]
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    applicationHistory.recruiter_notes
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    applicationHistory.note_creator
                                                      ? applicationHistory
                                                          .note_creator
                                                          .full_name
                                                      : ""
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    applicationHistory.recruiter_notes_created
                                                      ? _vm.convertDate(
                                                          applicationHistory.recruiter_notes_created
                                                        )
                                                      : ""
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ])
                                ])
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "AccordionItem",
            { attrs: { name: "all_ifact_checks" }, on: { opened: _vm.opened } },
            [
              _c("template", { slot: "accordion-trigger" }, [
                _vm._v("\n                All iFacts Checks\n            ")
              ]),
              _vm._v(" "),
              _c("template", { slot: "accordion-content" }, [
                _c("div", { staticClass: "cell small-12" }, [
                  _c("div", { staticClass: "grid-x grid-padding-x" }, [
                    _c(
                      "div",
                      { staticClass: "cell small-12 px-5" },
                      [
                        _c(
                          "Accordion",
                          _vm._l(
                            _vm.applicationHistories.filter(function(
                              applicationHistory
                            ) {
                              return (
                                applicationHistory
                                  .background_verification_results.length > 0
                              )
                            }),
                            function(applicationHistory) {
                              return _c(
                                "AccordionItem",
                                { key: applicationHistory.id },
                                [
                                  _c(
                                    "template",
                                    { slot: "accordion-trigger" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "grid-x grid-padding-x"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "cell p-0" },
                                            [
                                              _vm._v(
                                                "\n                                                Req #" +
                                                  _vm._s(
                                                    applicationHistory.job
                                                      .requisition_id
                                                  ) +
                                                  " " +
                                                  _vm._s(
                                                    applicationHistory.job.title
                                                  ) +
                                                  "   "
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href:
                                                      "/recruiter/active-requisitions/applicant/" +
                                                      _vm.jobApplication.id +
                                                      "#background_verification"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Go\n                                                    to application"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "template",
                                    { slot: "accordion-content" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "cell small-12" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "grid-x grid-padding-x px-3"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bg-white cell small-12 p-0"
                                                },
                                                [
                                                  applicationHistory
                                                    .background_verification_results
                                                    .length > 0
                                                    ? _c(
                                                        "table",
                                                        {
                                                          staticClass:
                                                            "unstriped"
                                                        },
                                                        [
                                                          _c("thead", [
                                                            _c("tr", [
                                                              _c("th", [
                                                                _vm._v("Check")
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("th", [
                                                                _vm._v("Result")
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("th", [
                                                                _vm._v(
                                                                  "Attachment"
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("th", [
                                                                _vm._v(
                                                                  "Manual Pass/Fail Override"
                                                                )
                                                              ])
                                                            ])
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "tbody",
                                                            _vm._l(
                                                              _vm.filteredBackgroundVerificationResults(
                                                                applicationHistory.background_verification_results
                                                              ),
                                                              function(bvr) {
                                                                return _c(
                                                                  "tr",
                                                                  {
                                                                    key: bvr.id
                                                                  },
                                                                  [
                                                                    _c("td", [
                                                                      _vm._v(
                                                                        "\n                                                                    " +
                                                                          _vm._s(
                                                                            bvr
                                                                              .background_verification_spec
                                                                              .title
                                                                          ) +
                                                                          "\n                                                                "
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("td", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          bvr.result_text
                                                                        )
                                                                      )
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("td", [
                                                                      bvr.result_file_cdn !==
                                                                      null
                                                                        ? _c(
                                                                            "a",
                                                                            {
                                                                              staticClass:
                                                                                "mb-3",
                                                                              attrs: {
                                                                                target:
                                                                                  "_blank",
                                                                                href:
                                                                                  "" +
                                                                                  bvr.result_file_cdn
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                                                        " +
                                                                                  _vm._s(
                                                                                    _vm.sliceString(
                                                                                      bvr.result_file
                                                                                    )
                                                                                  ) +
                                                                                  "\n                                                                    "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("td", [
                                                                      _c(
                                                                        "select",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                bvr.result,
                                                                              expression:
                                                                                "bvr.result"
                                                                            }
                                                                          ],
                                                                          staticClass:
                                                                            "border-0",
                                                                          on: {
                                                                            change: [
                                                                              function(
                                                                                $event
                                                                              ) {
                                                                                var $$selectedVal = Array.prototype.filter
                                                                                  .call(
                                                                                    $event
                                                                                      .target
                                                                                      .options,
                                                                                    function(
                                                                                      o
                                                                                    ) {
                                                                                      return o.selected
                                                                                    }
                                                                                  )
                                                                                  .map(
                                                                                    function(
                                                                                      o
                                                                                    ) {
                                                                                      var val =
                                                                                        "_value" in
                                                                                        o
                                                                                          ? o._value
                                                                                          : o.value
                                                                                      return val
                                                                                    }
                                                                                  )
                                                                                _vm.$set(
                                                                                  bvr,
                                                                                  "result",
                                                                                  $event
                                                                                    .target
                                                                                    .multiple
                                                                                    ? $$selectedVal
                                                                                    : $$selectedVal[0]
                                                                                )
                                                                              },
                                                                              function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.updateResultStatus(
                                                                                  bvr.id,
                                                                                  bvr.result
                                                                                )
                                                                              }
                                                                            ]
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "option"
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "option",
                                                                            {
                                                                              attrs: {
                                                                                value:
                                                                                  "pass"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Pass"
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "option",
                                                                            {
                                                                              attrs: {
                                                                                value:
                                                                                  "fail"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Fail"
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ])
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                2
                              )
                            }
                          ),
                          1
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "AccordionItem",
            { attrs: { name: "baseline_scores" }, on: { opened: _vm.opened } },
            [
              _c("template", { slot: "accordion-trigger" }, [
                _vm._v("\n                Baseline Scores\n            ")
              ]),
              _vm._v(" "),
              _c("template", { slot: "accordion-content" }, [
                _c("div", { staticClass: "card py-5" }, [
                  _c("div", { staticClass: "grid-x grid-padding-x mb-2" }, [
                    _c(
                      "div",
                      { staticClass: "cell small-12 medium-6 px-5" },
                      [
                        _c(
                          "vue-select",
                          {
                            attrs: {
                              label: "name",
                              filterable: false,
                              options: _vm.baselineOptions
                            },
                            on: {
                              search: _vm.searchBaselines,
                              open: _vm.searchBaselines
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _c("div", { staticClass: "d-center" }, [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(option.company_role.title) +
                                          " - " +
                                          _vm._s(option.area) +
                                          "\n                                    "
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "selected-option",
                                fn: function(option) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "selected d-center" },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(option.company_role.title) +
                                            " - " +
                                            _vm._s(option.area) +
                                            "\n                                    "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.baseline,
                              callback: function($$v) {
                                _vm.baseline = $$v
                              },
                              expression: "baseline"
                            }
                          },
                          [
                            _c("template", { slot: "no-options" }, [
                              _vm._v(
                                "\n                                    Type to search baseline\n                                "
                              )
                            ])
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "grid-x grid-padding-x" }, [
                    _c("div", { staticClass: "cell small-12 medium-12 px-5" }, [
                      _c("table", [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Baseline")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Score")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.baselineResults, function(baselineResult) {
                            return _c("tr", { key: baselineResult.id }, [
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    baselineResult.baseline.company_role.title
                                  ) +
                                    " - " +
                                    _vm._s(baselineResult.baseline.area)
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(baselineResult.score))])
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40cceba4", { render: render, staticRenderFns: staticRenderFns })
  }
}